import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { GetServiceRequestList } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const serviceRequestCountSlice = createAsyncThunk('get/serviceRequestCountSlice', GetServiceRequestList);

export const ServiceRequestSlice = createSlice({
	name: 'serviceRequestCountSlice',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[serviceRequestCountSlice.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[serviceRequestCountSlice.rejected.toString()]: setAPIError,
		[serviceRequestCountSlice.fulfilled.toString()]: (
			state: ReturnType<typeof INITIAL_STATE>,
			action: IAPI_ACTION<any>,
		) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = action.payload;
		},
	},
});

interface IStates {
	[ServiceRequestSlice.name]: ReturnType<typeof ServiceRequestSlice.reducer>;
}

export const serviceRequestSelector = (state: IStates): any => {
	return state[ServiceRequestSlice.name] || {};
};

export const useServiceRequest = (): any => useSelector(serviceRequestSelector);

export const getServiceRequest =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(serviceRequestCountSlice());
		return;
	};

export const resetServiceRequest =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(ServiceRequestSlice.actions.RESET());
		return;
	};
